import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import { apiWrapper } from "apis/CommonApi";
import * as api from "apis/PollingInverterModelApi";
import "./UsersPage.scss";

const empty = { modelName: "", functionCode: "04", startRegister: "0000", registerCount: 1 };

export default function PollingInverterModelsPage() {
  const [items, setItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState(empty);
  const [show, setShow] = useState(false);

  const load = () => apiWrapper(async () => {
    const result = await api.getModels();
    if (result.status) { setItems(result.data); setSelectedIds([]); }
  });
  useEffect(() => { load(); }, []);

  const preview = useMemo(() => {
    const fc = /^[0-9A-F]{2}$/i.test(form.functionCode) ? form.functionCode.toUpperCase() : "??";
    const start = /^[0-9A-F]{4}$/i.test(form.startRegister) ? form.startRegister.toUpperCase() : "????";
    const count = Number(form.registerCount);
    const countHex = Number.isInteger(count) && count > 0 ? count.toString(16).padStart(4, "0").toUpperCase() : "????";
    return `08 01 ${fc} ${start.slice(0,2)} ${start.slice(2)} ${countHex.slice(0,2)} ${countHex.slice(2)} CRC-L CRC-H`;
  }, [form]);

  const open = (item = null) => {
    setSelected(item);
    setForm(item ? { modelName: item.modelName, functionCode: item.functionCode, startRegister: item.startRegister, registerCount: item.registerCount } : empty);
    setShow(true);
  };
  const change = (name, value) => setForm({ ...form, [name]: value });
  const save = async () => {
    if (!form.modelName.trim()) return alert("인버터 모델명을 입력해주세요.");
    if (!/^[0-9A-F]{2}$/i.test(form.functionCode)) return alert("Function Code는 2자리 16진수입니다.");
    if (!/^[0-9A-F]{4}$/i.test(form.startRegister)) return alert("시작 레지스터는 4자리 16진수입니다.");
    const payload = { ...form, modelName: form.modelName.trim(), functionCode: form.functionCode.toUpperCase(), startRegister: form.startRegister.toUpperCase(), registerCount: Number(form.registerCount) };
    const result = selected ? await api.updateModel(selected.id, payload) : await api.createModel(payload);
    if (!result.status) return alert(`저장에 실패했습니다.\n${result.data}`);
    setShow(false); load();
  };
  const remove = async () => {
    if (!selectedIds.length || !window.confirm(`${selectedIds.length}개 모델을 삭제하시겠습니까?`)) return;
    const result = await api.deleteModels(selectedIds);
    if (!result.status) return alert(`삭제에 실패했습니다.\n${result.data}`);
    load();
  };

  return <div className="print-area">
    <Container fluid className="mb-3 d-flex align-items-center">
      <h1 className="title">Polling 인버터 모델 관리</h1>
      <span className="ms-auto"><Button onClick={() => open()}>추가</Button><Button className="ms-2" variant="danger" disabled={!selectedIds.length} onClick={remove}>삭제</Button></span>
    </Container>
    <Container fluid>
      <p className="text-muted">모델별 Modbus 요청 포맷을 정의합니다. 설비 Address, 길이와 CRC는 전송 시 자동 생성됩니다.</p>
      <Table bordered hover><thead className="table-header"><tr><th></th><th>No</th><th>인버터 모델명</th><th>Function Code</th><th>시작 레지스터</th><th>레지스터 수</th><th>Address 1 전송 예시</th></tr></thead>
      <tbody className="table-body">{items.map((item, index) => <tr key={item.id} onDoubleClick={() => open(item)}>
        <td><input type="checkbox" className="form-check-input" checked={selectedIds.includes(item.id)} onChange={e => setSelectedIds(e.target.checked ? [...selectedIds, item.id] : selectedIds.filter(id => id !== item.id))}/></td>
        <td>{index + 1}</td><td>{item.modelName}</td><td>0x{item.functionCode}</td><td>0x{item.startRegister}</td><td>{item.registerCount}</td><td><code>{item.requestCommandExample.match(/.{1,2}/g)?.join(" ")}</code></td>
      </tr>)}</tbody></Table>
    </Container>
    <Modal show={show} onHide={() => setShow(false)} centered><Modal.Header closeButton><Modal.Title>Polling 인버터 모델 {selected ? "수정" : "추가"}</Modal.Title></Modal.Header>
      <Modal.Body><Form>
        <Form.Group as={Row} className="mb-3"><Form.Label column sm={4}>모델명</Form.Label><Col><Form.Control value={form.modelName} onChange={e => change("modelName", e.target.value)} /></Col></Form.Group>
        <Form.Group as={Row} className="mb-3"><Form.Label column sm={4}>Function Code</Form.Label><Col><Form.Control maxLength={2} value={form.functionCode} onChange={e => change("functionCode", e.target.value.toUpperCase())}/></Col></Form.Group>
        <Form.Group as={Row} className="mb-3"><Form.Label column sm={4}>시작 레지스터</Form.Label><Col><Form.Control maxLength={4} value={form.startRegister} onChange={e => change("startRegister", e.target.value.toUpperCase())}/></Col></Form.Group>
        <Form.Group as={Row} className="mb-3"><Form.Label column sm={4}>요청 레지스터 수</Form.Label><Col><Form.Control type="number" min="1" max="125" value={form.registerCount} onChange={e => change("registerCount", e.target.value)}/></Col></Form.Group>
        <Form.Text>전송 포맷: <code>{preview}</code></Form.Text>
      </Form></Modal.Body><Modal.Footer><Button variant="secondary" onClick={() => setShow(false)}>취소</Button><Button onClick={save}>저장</Button></Modal.Footer>
    </Modal>
  </div>;
}
